import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminTrackingContractEdit_template } from '../../components/templates/recruiting/adminTrackingContractEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_tracking_contract_edit extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.references = {};
    }
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_tracking_contract_edit';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Contract');
        this.tpl = new adminTrackingContractEdit_template('adminTrackingContractEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading contract...');
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/tracking/partners', [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for references.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.references = JSON.parse(req.request.response || '{}');
                obj.loadParameterReferences();
            });
        };
    }
    /**
     * Load parameter references data from the API.
     *
     * @return void
     */
    loadParameterReferences() {
        this.loadParameter('AGEN', 'agencies', () => {
            this.loadParameter('REP', 'salesReps', () => {
                this.tpl.setReferences(this.references);
                this.loadContract();
            });
        });
    }
    /**
     * Load parameter data from the API.
     *
     * @param type string
     * @param target string
     * @param done Function
     * @return void
     */
    loadParameter(type, target, done) {
        const req = new XMLHttpRequestHandler('/api/admin/rest/api/lead/tracking/parameters?type=' + encodeURIComponent(type), [], this);
        req.onReadyStateFunction = function (request, obj) {
            return function () {
                obj.manageResponse(request, obj, function () {
                    obj.references[target] = JSON.parse(request.request.response || '[]');
                    done();
                });
            };
        };
        req.execute();
    }
    /**
     * Load contract data from the API.
     *
     * @return void
     */
    loadContract() {
        const contractId = this.getContractId();
        if (!contractId) {
            this.tpl.setContract({
                channel: 'REC',
                quotaAlert: 1,
                automaticTurnOn: 1,
                automaticTurnOff: 1,
                partnerIds: [],
            });
            hideLoadingOverlay(this.tpl.builtTemplate);
            return;
        }
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/tracking/contract/' + contractId, [], this);
        this.XHRHdl.onReadyStateFunction = this.onContractReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for contract.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onContractReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setContract(responseParsed, obj.isDuplicate());
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Save contract through the API.
     *
     * @return Promise<void>
     */
    async saveContract() {
        const payload = this.tpl.getPayload();
        if (!payload.name) {
            alert('Campaign name is required.');
            return;
        }
        if (!payload.startDate || !payload.endDate) {
            alert('Start and end dates are required.');
            return;
        }
        if (!payload.partnerIds || payload.partnerIds.length === 0) {
            alert('At least one partner is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving contract...');
        const response = await fetch('/api/admin/rest/api/lead/tracking/contract', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save contract.');
            return;
        }
        page('/admin/contract/' + result.objectId);
    }
    /**
     * Navigate back to contracts.
     *
     * @return void
     */
    backToContracts() {
        page('/admin/contracts');
    }
    /**
     * Return contract id.
     *
     * @return number
     */
    getContractId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
    /**
     * Handle is duplicate.
     *
     * @return boolean
     */
    isDuplicate() {
        return String(document.location.pathname || '').indexOf('/admin/contract-duplicate/') !== -1;
    }
}
